import { Button, Input, InputRef, Space } from 'antd';
import { ColumnType , ColumnsType } from 'antd/es/table';
import Table from 'antd/es/table';
import { FilterConfirmProps } from 'antd/es/table/interface';
import React, { useEffect } from 'react'
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';

interface DataType {
key: React.Key;
sowId: string;
sowName: string;
clientEntity: string;
child: boolean;
sowStartDate: string;
sowEndDate: string;
currency: string;
contractValue: string;
contractValueUsd: string;
sowWithoutOpportunitySinceDate: string;
sowWithoutOpportunitySinceNumberOfDays: string;
sowWithoutWorkOrderSinceDate: string;
sowWithoutWorkOrderSinceNumberOfDays: string;
sowBu: string | null;
}

type DataIndex = keyof DataType;

const SowAgeingWithoutOpp = (props:any) => {

    const [searchText, setSearchText] = React.useState('');
    const [searchedColumn, setSearchedColumn] = React.useState('');
    const searchInput = React.useRef<InputRef>(null);

    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
      ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    
      const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
      };
      const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<any> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
          <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
            <Input
              ref={searchInput}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
              style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button
                onClick={() => {
                  setSelectedKeys([]);
                  handleSearch([], confirm, dataIndex);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered: boolean) => (
          <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilter: (value, record) =>
        record[dataIndex] && record[dataIndex]
            .toString()
            .toLowerCase()
            .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
          if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
          }
        },
        render: (text) =>
          searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          ),
      });

    useEffect(() => {

    },[props.sowWithoutOpportunityList])

    const Columns_SOW_without_opp: ColumnsType<DataType> = [
        {
            title: 'SOW Id',
            dataIndex: 'sowId',
            key: 'sowId',
            width: 100,
            fixed: 'left',
            ...getColumnSearchProps('sowId')
        },
        {
            title:'SOW Name',
            dataIndex: 'sowName',
            key: 'sowName',
            width: 200,
            fixed: 'left',
            
        },
        {
            title: 'Client Entity',
            dataIndex: 'clientEntity',
            key: 'clientEntity',
            width: 200,
            ...getColumnSearchProps('clientEntity')
        },
        {
            title:"Is Child?",
            dataIndex: 'child',
            key: 'child', 
            width: 110,
            ...getColumnSearchProps('child')
        },
        {
            title: 'SOW Start Date',
            dataIndex: 'sowStartDate',
            key: 'sowStartDate',
            width: 150
        },
        {
            title: 'SOW End Date',
            dataIndex: 'sowEndDate',
            key: 'sowEndDate',
            width: 150
        },
        {
            title:'Currency',
            dataIndex: 'currency',
            key: 'currency',
            width: 100
        },
        {
            title: 'Contract Value',
            dataIndex: 'contractValue',
            key: 'contractValue',
            width: 200
        },
        {
            title: 'Contract Value (USD)',
            dataIndex: 'contractValueUsd',
            key: 'contractValueUsd',
            width: 200
        },
        {
          title: 'Delivery Lead',
          dataIndex: 'deliveryLead',
          key: 'deliveryLead',
          width: 200
        },
        {
          title: 'Business Unit',
          dataIndex: 'sowBu',
          key: 'sowBu',
          width: 150,
          ...getColumnSearchProps('sowBu'),
        },
        {
          title: 'Service Line',
          dataIndex: 'serviceLine',
          key: 'serviceLine',
          width: 200
        },
        {
            title: 'SOW Without Opportunity Since (Date)',
            dataIndex: 'sowWithoutOpportunitySinceDate',
            key: 'sowWithoutOpportunitySinceDate',
            width: 210,
            fixed: 'right',
            

        },
        {
            title: 'SOW Without Opportunity Since (Days)',
            dataIndex: 'sowWithoutOpportunitySinceNumberOfDays',
            key: 'sowWithoutOpportunitySinceNumberOfDays',
            width: 210,
            fixed: 'right',
            ...getColumnSearchProps('sowWithoutOpportunitySinceNumberOfDays')

        }

    ];

    const sortAccending = (List:DataType[]) => {
      
        return List.sort((a:any,b:any) => {
            return a.sowWithoutOpportunitySinceNumberOfDays - b.sowWithoutOpportunitySinceNumberOfDays;
        })
    }

  return (
    <div>
           <Table 
                className='table-style'
                columns={Columns_SOW_without_opp} 
                dataSource={sortAccending(props.sowWithoutOpportunityList) } 
                scroll={{ x: 'max-content', y: 350}}
                pagination={{ pageSize: 10, showSizeChanger: false }}
                />
        </div> 
  )
}

export default SowAgeingWithoutOpp